import s from './OilHeaderFields.module.scss';

interface OilHeaderFieldsProps {
  shipName: string;
  registrationNumber: string;
}

export function OilHeaderFields({ shipName, registrationNumber }: OilHeaderFieldsProps) {
  return (
    <div className={s.root}>
      <HeaderCell label="Ship Name" value={shipName} />
      <HeaderCell label="Registration Number/ID" value={registrationNumber} />
      <HeaderCell label="Record" value="Bunker & Oil Records" />
    </div>
  );
}

function HeaderCell({ label, value }: { label: string; value: string }) {
  return (
    <div className={s.cell}>
      <span className={s.label}>{label}</span>
      <span className={s.value}>{value || '-'}</span>
    </div>
  );
}
